import { convertLegacyRouteRef } from '@backstage/core-compat-api'
import {
  coreExtensionData,
  createExtensionInput,
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api'
import { catalogPlugin, CatalogTable, CatalogTableColumnsFunc } from '@backstage/plugin-catalog'
import CategoryIcon from '@material-ui/icons/Category'
import { Fragment } from 'react'

const SERVICE_TIER_LABEL = 'shipveho.com/service-tier'

const columns: CatalogTableColumnsFunc = entityListContext =>
  [
    ...CatalogTable.defaultColumnsFunc(entityListContext),
    CatalogTable.columns.createLabelColumn(SERVICE_TIER_LABEL, {
      title: 'Service Tier',
    }),
  ].filter(column => column.field !== 'entity.spec.lifecycle')

const catalogPage = PageBlueprint.makeWithOverrides({
  inputs: {
    filters: createExtensionInput([coreExtensionData.reactElement]),
  },
  factory(originalFactory, { inputs }) {
    return originalFactory({
      path: '/catalog',
      title: 'Catalog',
      routeRef: convertLegacyRouteRef(catalogPlugin.routes.catalogIndex),
      icon: <CategoryIcon fontSize="inherit" />,
      loader: async () => {
        const { CatalogIndexPage } = await import('@backstage/plugin-catalog/alpha')
        const filters = inputs.filters.map(filter => filter.get(coreExtensionData.reactElement))
        return <CatalogIndexPage columns={columns} filters={<Fragment>{filters}</Fragment>} />
      },
    })
  },
})

export const catalogPageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPage],
})
